export enum ResourceKindEnum {
	Agreement = 0,
	Application = 1,
	Attachment = 2,
	Computer = 3,
	Device = 4,
	DisplayDevice = 5,
	Document = 6,
	Employee = 7,
	Invoice = 8,
	Letter = 9,
	LicenseDocument = 10,

	MobileDevice = 11,
	Modem = 12,
	NetworkDevice = 13,
	OtherDocument = 14,
	OtherResourceNode = 15,
	Printer = 16,
	ResourceGroup = 17,
	ServiceAsset = 18,
	SimCard = 19,
	StorageDevice = 20,

	Vehicle = 21,
	Warranty = 22,
	Training = 23,
	BusinessProcess = 24,
	DataSet = 25,
	ResourceLocation = 26,
	PersonProfile = 27,
}

export interface IResourceListItem {
	AcceptantId: string,
	ApplicationName: string,
	BarCode: string,
	Category: string,
	Company: string,
	Department: string,
	EmployeeCompany: string,
	EmployeeId: number,
	EmployeeName: string,
	GivenName: string,
	HRId: string,
	Id: number,
	IssueId?: number,
	Kind: string,
	KindEnum: ResourceKindEnum,
	Manufacturer: string,
	Model: string,
	MpkNumber: string,
	Name: string,
	ReferenceNumber: string,
	Relation: string,
	RelationId: string,
	ReplacementDate: string,
	SAPId: string,
	STNumber: string,
	Selected: boolean,
	SerialNumber: string,
	Status: string,
	Surname: string,
	Type: string,
	UsageType: string,
	Email: string,
}

export interface IResourceData {
	AcceptantId: string,
	AdministratorLogin: string,
	AdministratorResourceId: string,
	ApplicationName: string,
	BussinesOwnerLogin: string,
	BussinesOwnerResourceId: string,
	Category: string,
	Company: string,
	DataProtectionOfficerLogin: string,
	DataProtectionOfficerResourceId: string,
	Department: string,
	EmployeeCompany: string,
	GivenName: string,
	HRId: string,
	Id: string,
	Kind: string,
	Link: string,
	LinkVNC: string,
	LogId: number,
	Model: string,
	MpkNumber: string,
	Name: string,
	QDeskAccount: string,
	ReferenceNumber: string,
	SAPId: string,
	STNumber: string,
	SerialNumber: string,
	Status: string,
	Surname: string,
	Type: string,
};


export type ControlType = "" | "RelatedResource" | "EmployeeRelatedResources";